import { Component, effect, inject, Input, OnInit, signal } from '@angular/core';
import { VideoCompleteReviewResponseDto, VideoResponseDto } from '../../../../../common/general-types/videos.dto';
import { ApplicationStatusEnum, BriefApplicationResponseDto, SocialChannelEnum } from '../../../../../common/general-types/briefs.dto';
import { environment } from '../../../../../../environments/environment';
import { ChoosePlanService } from '../../../../choose-plan/service/choose-plan/choose-plan.service';
import { ImageService } from '../../../../../services/image/image.service';
import { FormatService } from '../../../../../common/format/format.service';
import { CreatorResponseDto } from '../../../../../common/general-types/creators.dto';
import { VideoThumbnailComponent } from '../../../../../atoms/video-thumbnail/video-thumbnail.component';
import { VideoFeedbackComponent } from '../../../../../pages/view-submission/molecules/video-feedback/video-feedback.component';
import { ManageBriefTabsService } from '../../../service/manage-brief-tabs/manage-brief-tabs.service';

@Component({
  selector: 'brief-feed-ready-to-post',
  standalone: true,
  imports: [VideoThumbnailComponent, VideoFeedbackComponent],
  templateUrl: './feed-ready-to-post.component.html',
  styleUrl: './feed-ready-to-post.component.css'
})
export class FeedReadyToPostComponent {

  environment = environment;

  @Input('activity') activity!: {
    applicationStatus: ApplicationStatusEnum;
    briefApplication: BriefApplicationResponseDto;
    date: Date;
    videoAiModeration: VideoCompleteReviewResponseDto;
    video: VideoResponseDto;
  };

  creator = signal<CreatorResponseDto | undefined>(undefined);
  showVideoFeedback = signal<VideoResponseDto | undefined>(undefined);

   /** Services */
   public formatService = inject(FormatService);
   public imageService = inject(ImageService);
   public choosePlanService = inject(ChoosePlanService);
   private manageBriefTabsService = inject(ManageBriefTabsService);
   /** Services END */

   constructor() {
    effect(() => {
      this.openFeedbackFromRoute(this.manageBriefTabsService.videoFeedbackCreatorId());
    });
   }

   ngOnInit(): void {
    this.creator.set(this.activity.video.creator);
    this.openFeedbackFromRoute(this.manageBriefTabsService.videoFeedbackCreatorId());
  }

  viewContent(video: VideoResponseDto) {
    this.showVideoFeedback.set(video);
    this.creator.set(video.creator);
    const creatorId = video.creator?.blazeFirebaseUid ?? this.activity.briefApplication.creator?.blazeFirebaseUid;
    if (creatorId) {
      this.manageBriefTabsService.navigateToVideoFeedback(creatorId);
    }
  }

  closeVideoFeedback(): void {
    this.showVideoFeedback.set(undefined);
    this.manageBriefTabsService.clearVideoFeedbackRoute();
  }

  private openFeedbackFromRoute(creatorId: string | undefined): void {
    if (!creatorId || !this.activity) {
      return;
    }
    const activityCreatorId =
      this.activity.video?.creator?.blazeFirebaseUid ?? this.activity.briefApplication?.creator?.blazeFirebaseUid;
    if (activityCreatorId !== creatorId) {
      return;
    }
    if (this.showVideoFeedback()?.id === this.activity.video.id) {
      return;
    }
    this.showVideoFeedback.set(this.activity.video);
    this.creator.set(this.activity.video.creator ?? this.activity.briefApplication.creator);
  }

  getIsUgcOnly(): boolean {
    if (this.activity.briefApplication.brief && this.activity.briefApplication.brief.shoutBrief) {
      return false;
    } else {
      return true;
    }
  }

  getHandleAndNetwork() {
    let socialChannel;
    let channelName = '';
    let handle = '';
    if (this.getIsUgcOnly()) {
      socialChannel = SocialChannelEnum['Not Set'];
      channelName = 'UGC Only';
    } else {
      socialChannel = this.activity.briefApplication.brief?.shoutBrief?.socialPlatform ?? SocialChannelEnum['Not Set'];
      channelName = this.getChannelName(socialChannel);
    }

    

    if (socialChannel === SocialChannelEnum['TikTok Post']) {
      channelName = 'TikTok';
      handle = this.activity.briefApplication.creator?.tikTokHandle ?? '';
    } else if (socialChannel === SocialChannelEnum['Instagram Reel']) {
      channelName = 'Instagram Reel';
      handle = this.activity.briefApplication.creator?.instaHandle ?? '';
    } else if (socialChannel === SocialChannelEnum['YouTube Shorts']) {
      channelName = 'YouTube Shorts';
      handle = this.activity.briefApplication.creator?.youtubeHandle ?? '';
    } else {
      channelName = 'Unknown';
    }
    if (this.getIsUgcOnly()) {
      return `${ this.activity.briefApplication.creator!.firstName } will not post this - UGC Only brief`;
    } else {
      return `${ this.activity.briefApplication.creator!.firstName } will post to @${ handle } on ${ channelName }`;
    }
  }

  getChannelName(channel: SocialChannelEnum) {
    switch (channel) {
      case SocialChannelEnum['TikTok Post']:
        return 'TikTok';
      case SocialChannelEnum['Instagram Reel']:
        return 'Instagram Reel';
      case SocialChannelEnum['YouTube Shorts']:
        return 'YouTube Shorts';
      case SocialChannelEnum['Not Set']:
        return 'UGC Only';
    }
    return 'Unknown';
  }
}
